import { render, staticRenderFns } from "./alerts-overview-table.vue?vue&type=template&id=748c7740"
import script from "./alerts-overview-table.vue?vue&type=script&lang=js"
export * from "./alerts-overview-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports